import * as actionTypes from "../constants/actionTypes";

export const initialState = {
  modalType: undefined,
  modalProps: {}
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MODAL_OPEN:
      return {
        modalType: action.modalType,
        modalProps: action.modalProps
      };
    case actionTypes.MODAL_CLOSE:
      return {
        modalType: null,
        modalProps: {}
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/modals.js